<div [id]="id" [style.height]="height()" [class.readonly]="readonly()" #mapElement></div>
